// SVXS theme interactions
(function () {
  function initProductGalleries(root) {
    root.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryReady) return;
      var track = gallery.querySelector('[data-gallery-track]');
      var dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
      if (!track || dots.length < 2) return;
      gallery.dataset.galleryReady = 'true';
      var current = 0;
      var frame = 0;
      function update() {
        frame = 0;
        if (!track.clientWidth) return;
        current = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-current', String(index === current));
        });
      }
      function goTo(index, instant) {
        index = Math.max(0, Math.min(dots.length - 1, index));
        track.scrollTo({ left: index * track.clientWidth, behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { goTo(index); });
      });
      track.addEventListener('scroll', function () {
        if (!frame) frame = requestAnimationFrame(update);
      }, { passive: true });
      gallery.addEventListener('keydown', function (event) {
        if (event.target !== track && !dots.includes(event.target)) return;
        var index = dots.includes(event.target) ? dots.indexOf(event.target) : current;
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = dots.length - 1;
        else return;
        event.preventDefault();
        index = Math.max(0, Math.min(dots.length - 1, index));
        goTo(index);
        if (event.target !== track) dots[index].focus({ preventScroll: true });
      });
      if (window.ResizeObserver) {
        var observer = new ResizeObserver(function () {
          if (!gallery.isConnected) { observer.disconnect(); return; }
          goTo(current, true);
        });
        observer.observe(track);
        document.addEventListener('shopify:section:unload', function unload(event) {
          if (!event.target.contains(gallery)) return;
          observer.disconnect();
          cancelAnimationFrame(frame);
          document.removeEventListener('shopify:section:unload', unload);
        });
      }
      gallery.querySelector('[data-gallery-dots]').hidden = false;
      update();
    });
  }
  initProductGalleries(document);
  function initSizeChartDialogs(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-size-chart-trigger]').forEach(function (trigger) {
      if (trigger.dataset.sizeChartReady) return;
      var dialogId = trigger.getAttribute('aria-controls');
      var dialog = dialogId && document.getElementById(dialogId);
      var closeButton = dialog && dialog.querySelector('[data-size-chart-close]');
      if (!dialog || !closeButton || typeof dialog.showModal !== 'function') return;
      trigger.dataset.sizeChartReady = 'true';
      var unloading = false;
      var syncClosedState = function () {
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('size-chart-dialog-open');
        if (!unloading && trigger.isConnected) trigger.focus({ preventScroll: true });
      };
      var closeDialog = function () {
        if (dialog.open) dialog.close();
        syncClosedState();
      };
      var handleClose = function () { syncClosedState(); };
      var handleOpen = function () {
        if (dialog.open) return;
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('size-chart-dialog-open');
        closeButton.focus({ preventScroll: true });
      };
      var handleDialogClick = function (event) {
        if (event.target === dialog) closeDialog();
      };
      var handleCancel = function (event) {
        event.preventDefault();
        closeDialog();
      };
      var handleSectionUnload = function (event) {
        if (!event.target.contains(trigger) && !event.target.contains(dialog)) return;
        unloading = true;
        closeDialog();
        trigger.removeEventListener('click', handleOpen);
        closeButton.removeEventListener('click', closeDialog);
        dialog.removeEventListener('click', handleDialogClick);
        dialog.removeEventListener('cancel', handleCancel);
        dialog.removeEventListener('close', handleClose);
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
      };
      trigger.addEventListener('click', handleOpen);
      closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('click', handleDialogClick);
      dialog.addEventListener('cancel', handleCancel);
      dialog.addEventListener('close', handleClose);
      document.addEventListener('shopify:section:unload', handleSectionUnload);
    });
  }
  initSizeChartDialogs(document);
  document.addEventListener('shopify:section:load', function (event) {
    initProductGalleries(event.target);
    initSizeChartDialogs(event.target);
  });

  // AJAX cart drawer: keep shoppers on the current page after adding an item.
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastCartOpener = null;
  if (drawer) {
    var drawerBody = drawer.querySelector('[data-cart-drawer-body]');
    var drawerFooter = drawer.querySelector('[data-cart-drawer-footer]');
    var moneyFormat = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? null : null;
    var formatMoney = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'id-ID', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'IDR', maximumFractionDigits: 0 }).format(cents / 100); }
      catch (e) { return 'Rp ' + Math.round(cents / 100).toLocaleString('id-ID'); }
    };
    var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js';
    var quickModal = document.querySelector('[data-quick-add-modal]');
    var quickModalTitle = quickModal && quickModal.querySelector('[data-quick-add-title]');
    var quickModalPrice = quickModal && quickModal.querySelector('[data-quick-add-price]');
    var quickModalOptions = quickModal && quickModal.querySelector('[data-quick-add-options]');
    var quickModalQuantity = quickModal && quickModal.querySelector('[data-quick-add-quantity]');
    var quickModalDecrease = quickModal && quickModal.querySelector('[data-quick-add-decrease]');
    var quickModalIncrease = quickModal && quickModal.querySelector('[data-quick-add-increase]');
    var quickModalTotal = quickModal && quickModal.querySelector('[data-quick-add-total]');
    var quickModalSubmit = quickModal && quickModal.querySelector('[data-quick-add-submit]');
    var quickModalOpener = null;
    var quickModalVariant = null;
    var quickModalVariantList = [];
    var quickModalQuantityValue = 1;
    var setBusy = function (busy) { drawer.setAttribute('aria-busy', String(busy)); };
    var updateCounts = function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      document.querySelectorAll('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
      var subtotal = drawer.querySelector('[data-cart-subtotal]'); if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (drawerFooter) drawerFooter.hidden = cart.item_count === 0;
    };
    var renderCart = function (cart) {
      updateCounts(cart);
      if (!cart.items.length) { drawerBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>'; return; }
      drawerBody.innerHTML = cart.items.map(function (item, index) {
        var image = item.image ? '<img class="cart-drawer__image" loading="lazy" src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '">' : '';
        return '<article class="cart-drawer__item" data-cart-item data-line="' + (index + 1) + '">' +
          '<a href="' + item.url + '" class="cart-drawer__media">' + image + '</a>' +
          '<div class="cart-drawer__info"><a href="' + item.url + '" class="cart-drawer__name">' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__meta">' + item.variant_title + '</p>' : '') +
          '<p class="cart-drawer__price">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="cart-drawer__qty" data-drawer-qty><button type="button" data-drawer-decrease aria-label="Decrease quantity">−</button><span data-drawer-quantity>' + item.quantity + '</span><button type="button" data-drawer-increase aria-label="Increase quantity">+</button></div></div>' +
          '<button type="button" class="cart-drawer__remove" data-drawer-remove aria-label="Remove ' + item.product_title.replace(/"/g, '&quot;') + '">Remove</button></article>';
      }).join('');
    };
    var getCart = function () { return fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(function (response) { if (!response.ok) throw new Error('Cart request failed'); return response.json(); }); };
    var changeLine = function (line, quantity) {
      setBusy(true);
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }) }).then(function (response) { if (!response.ok) throw new Error('Cart update failed'); return response.json(); }).then(renderCart).finally(function () { setBusy(false); });
    };
    var openDrawer = function (opener) { lastCartOpener = opener || lastCartOpener; if (lastCartOpener) lastCartOpener.setAttribute('aria-expanded', 'true'); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('cart-drawer-open'); var close = drawer.querySelector('[data-cart-close]'); if (close) close.focus(); };
    var closeDrawer = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('cart-drawer-open'); if (lastCartOpener) lastCartOpener.setAttribute('aria-expanded', 'false'); if (lastCartOpener && lastCartOpener.focus) lastCartOpener.focus({ preventScroll: true }); };
    var closeQuickModal = function () {
      if (!quickModal) return;
      quickModal.hidden = true;
      quickModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('quick-add-modal-open');
      quickModalVariant = null;
      quickModalVariantList = [];
      quickModalQuantityValue = 1;
      if (quickModalOpener) quickModalOpener.focus({ preventScroll: true });
    };
    var addVariantToCart = function (variantId, opener, labelTarget, quantity) {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', String(quantity || 1));
      var labelNode = labelTarget && labelTarget.querySelector('[data-quick-add-label]');
      var label = labelNode ? labelNode.textContent : (labelTarget ? labelTarget.textContent : '');
      var setLabel = function (value) {
        if (labelNode) labelNode.textContent = value;
        else if (labelTarget) labelTarget.textContent = value;
      };
      if (labelTarget) { labelTarget.disabled = true; setLabel('Adding…'); }
      setBusy(true);
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
        .then(function (response) { if (!response.ok) throw new Error('Add to cart failed'); return getCart(); })
        .then(function (cart) { renderCart(cart); closeQuickModal(); openDrawer(opener); })
        .catch(function () { if (labelTarget) setLabel('Try again'); })
        .finally(function () {
          setBusy(false);
          if (labelTarget) {
            labelTarget.disabled = false;
            var currentLabel = labelNode ? labelNode.textContent : labelTarget.textContent;
            if (currentLabel === 'Adding…') setLabel(label);
          }
        });
    };
    var openQuickModal = function (button, product) {
      var variants = (product.variants || []).filter(function (variant) { return variant.available; });
      if (variants.length <= 1) { addVariantToCart((variants[0] || {}).id || button.dataset.variantId, button, button); return; }
      quickModalOpener = button;
      quickModalVariant = null;
      quickModalVariantList = variants;
      quickModalQuantityValue = 1;
      quickModalTitle.textContent = product.title || button.dataset.productTitle || 'Select a variant';
      var defaultPrice = (variants[0] || {}).price || product.price || 0;
      quickModalPrice.textContent = formatMoney(defaultPrice);
      quickModalTotal.textContent = formatMoney(defaultPrice);
      quickModalQuantity.textContent = '1';
      quickModalDecrease.disabled = true;
      quickModalOptions.innerHTML = variants.map(function (variant) {
        var label = variant.title && variant.title !== 'Default Title' ? variant.title : 'Default';
        return '<button type="button" class="quick-add-modal__option" data-quick-add-variant="' + variant.id + '" aria-pressed="false">' + label + '</button>';
      }).join('');
      quickModalSubmit.disabled = true;
      quickModal.hidden = false;
      quickModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('quick-add-modal-open');
      var first = quickModalOptions.querySelector('button');
      if (first) first.focus();
    };
    var updateQuickModalPrice = function () {
      if (!quickModalVariant) return;
      var price = Number(quickModalVariant.price || 0);
      quickModalPrice.textContent = formatMoney(price);
      quickModalTotal.textContent = formatMoney(price * quickModalQuantityValue);
    };
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-cart-open]');
      if (open) { event.preventDefault(); getCart().then(renderCart).then(function () { openDrawer(open); }).catch(function () { window.location.href = open.href; }); return; }
      if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }
      if (event.target.closest('[data-quick-add-close]')) { event.preventDefault(); closeQuickModal(); return; }
      var quickOption = event.target.closest('[data-quick-add-variant]');
      if (quickOption && quickModalOptions && quickModalOptions.contains(quickOption)) {
        quickModalOptions.querySelectorAll('[data-quick-add-variant]').forEach(function (option) { option.setAttribute('aria-pressed', option === quickOption ? 'true' : 'false'); option.classList.toggle('is-selected', option === quickOption); });
        quickModalVariant = (quickModalVariantList || []).find(function (variant) { return String(variant.id) === quickOption.dataset.quickAddVariant; }) || { id: quickOption.dataset.quickAddVariant };
        updateQuickModalPrice();
        quickModalSubmit.disabled = false;
        return;
      }
      if (event.target.closest('[data-quick-add-decrease]') && quickModalQuantityValue > 1) { quickModalQuantityValue--; quickModalQuantity.textContent = String(quickModalQuantityValue); quickModalDecrease.disabled = quickModalQuantityValue === 1; updateQuickModalPrice(); return; }
      if (event.target.closest('[data-quick-add-increase]')) { quickModalQuantityValue++; quickModalQuantity.textContent = String(quickModalQuantityValue); quickModalDecrease.disabled = false; updateQuickModalPrice(); return; }
      var item = event.target.closest('[data-cart-item]'); if (!item) return;
      var qty = Number(item.querySelector('[data-drawer-quantity]')?.textContent || 0); var line = Number(item.dataset.line);
      if (event.target.closest('[data-drawer-increase]')) changeLine(line, qty + 1);
      if (event.target.closest('[data-drawer-decrease]')) changeLine(line, qty - 1);
      if (event.target.closest('[data-drawer-remove]')) changeLine(line, 0);
    });
    document.addEventListener('keydown', function (event) { if (event.key !== 'Escape') return; if (quickModal && !quickModal.hidden) closeQuickModal(); else if (drawer.classList.contains('is-open')) closeDrawer(); });
    document.querySelectorAll('.product__form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault(); setBusy(true);
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }).then(function (response) { if (!response.ok) throw new Error('Add to cart failed'); return getCart(); }).then(function (cart) { renderCart(cart); openDrawer(form.querySelector('[name="add"]')); }).catch(function () { form.submit(); }).finally(function () { setBusy(false); });
      });
    });
    document.querySelectorAll('[data-quick-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!window.fetch || button.disabled) return;
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + button.dataset.productHandle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { if (!response.ok) throw new Error('Product request failed'); return response.json(); })
          .then(function (product) { openQuickModal(button, product); })
          .catch(function () { addVariantToCart(button.dataset.variantId, button, button); });
      });
    });
    if (quickModalSubmit) quickModalSubmit.addEventListener('click', function () { if (quickModalVariant) addVariantToCart(quickModalVariant.id, quickModalOpener, quickModalSubmit, quickModalQuantityValue); });
  }

  // Global reload tile-wipe overlay (diagonal mosaic)
  var overlay = document.getElementById('GlobalReloadTransition');
  if (overlay) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      overlay.remove();
    } else {
      var w = window.innerWidth;
      var cols = w >= 1000 ? 6 : (w >= 600 ? 4 : 3);
      var rows = w >= 1000 ? 4 : (w >= 600 ? 4 : 5);
      overlay.style.setProperty('--columns', cols);
      overlay.style.setProperty('--rows', rows);
      var frag = document.createDocumentFragment();
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var t = document.createElement('div');
          t.className = 'tile';
          t.style.setProperty('--row', r);
          t.style.setProperty('--col', c);
          frag.appendChild(t);
        }
      }
      overlay.appendChild(frag);
      overlay.style.background = 'transparent';
      var total = (rows - 1 + cols - 1) * 48 + 700 + 80;
      setTimeout(function () { overlay.remove(); }, total);
    }
  }

  // Announcement bar dismiss (persists per session)
  var ann = document.querySelector('[data-announcement]');
  if (ann) {
    try {
      if (sessionStorage.getItem('svxs-ann-dismissed')) {
        ann.style.display = 'none';
        document.documentElement.style.setProperty('--ann-h', '0px');
      }
    } catch (e) {}
    var annClose = ann.querySelector('[data-announcement-close]');
    if (annClose) annClose.addEventListener('click', function () {
      ann.style.display = 'none';
      document.documentElement.style.setProperty('--ann-h', '0px');
      try { sessionStorage.setItem('svxs-ann-dismissed', '1'); } catch (e) {}
    });
  }

  // Newsletter popup
  var nl = document.querySelector('[data-newsletter]');
  if (nl) {
    var snoozeUntil = 0;
    try { snoozeUntil = Number(localStorage.getItem('svxs-nl-snooze-until') || 0); } catch (e) {}
    var snoozed = snoozeUntil > Date.now();
    var delay = Number(nl.getAttribute('data-delay')) || 3000;
    var opener = null;
    var dismiss = function () {
      nl.classList.remove('is-open');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    };
    var snooze = function () {
      try { localStorage.setItem('svxs-nl-snooze-until', String(Date.now() + 14 * 24 * 60 * 60 * 1000)); } catch (e) {}
      dismiss();
    };
    var open = function () {
      nl.classList.add('is-open');
      opener = document.activeElement;
      var input = nl.querySelector('input[type="email"]');
      if (input) input.focus({ preventScroll: true });
    };
    if (!snoozed) setTimeout(open, delay);
    nl.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
      el.addEventListener('click', snooze);
    });
    nl.querySelectorAll('[data-newsletter-snooze]').forEach(function (el) {
      el.addEventListener('click', snooze);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nl.classList.contains('is-open')) { event.preventDefault(); dismiss(); }
    });
  }

  // Currency label toggle (display only)
  var cur = document.querySelector('[data-currency] span');
  if (cur) {
    var c = 'IDR';
    try { c = localStorage.getItem('svxs-currency') || 'IDR'; } catch (e) {}
    cur.textContent = c;
    cur.parentNode.addEventListener('click', function () {
      c = c === 'IDR' ? 'USD' : 'IDR';
      cur.textContent = c;
      try { localStorage.setItem('svxs-currency', c); } catch (e) {}
    });
  }

  // Product page: map selected options to variant id
  document.querySelectorAll('.product__form').forEach(function (form) {
    var idField = form.querySelector('input[name="id"]');
    var variants = window.__svxsVariants;
    if (!variants || !idField) return;
    form.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = Array.from(form.querySelectorAll('input[type="radio"]:checked')).map(function (i) { return i.value; });
        var match = variants.find(function (v) { return selected.every(function (s) { return v.options.includes(s); }); });
        if (match) idField.value = match.id;
      });
    });
  });
  // Homepage: header becomes solid on scroll
  var header = document.querySelector('.header');
  if (header && document.body.classList.contains('template-index')) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > window.innerHeight * 0.7); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  // Collection: grid density toggle
  var grid = document.querySelector('.product-grid--collection');
  document.querySelectorAll('.collection__views button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!grid) return;
      grid.setAttribute('data-cols', b.getAttribute('data-cols'));
      document.querySelectorAll('.collection__views button').forEach(function (x) {
        x.classList.remove('is-active');
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      b.classList.add('is-active');
    });
  });
  // Collection: progressively load the next batch while keeping crawlable pagination as a fallback.
  var loadMore = document.querySelector('[data-load-more]');
  if (loadMore) {
    var collectionGrid = document.querySelector('.product-grid--collection');
    var collectionPagination = document.querySelector('.collection__pagination');
    var paginationNav = collectionPagination && collectionPagination.querySelector('.pagination');
    var loading = false;
    if (paginationNav) paginationNav.hidden = true;
    loadMore.addEventListener('click', function () {
      if (loading || !loadMore.dataset.nextUrl || !collectionGrid) return;
      loading = true;
      loadMore.disabled = true;
      loadMore.setAttribute('aria-busy', 'true');
      var originalLabel = loadMore.textContent;
      loadMore.textContent = 'Loading…';
      fetch(loadMore.dataset.nextUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Collection page could not be loaded');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('.product-grid--collection');
          var nextButton = doc.querySelector('[data-load-more]');
          if (!nextGrid) throw new Error('Collection grid missing');
          Array.from(nextGrid.children).forEach(function (card) { collectionGrid.appendChild(card); });
          if (nextButton && nextButton.dataset.nextUrl) {
            loadMore.dataset.nextUrl = nextButton.dataset.nextUrl;
            loadMore.disabled = false;
            loadMore.removeAttribute('aria-busy');
            loadMore.textContent = originalLabel;
          } else {
            loadMore.remove();
          }
        })
        .catch(function () {
          loadMore.disabled = false;
          loadMore.removeAttribute('aria-busy');
          loadMore.textContent = originalLabel;
          if (paginationNav) paginationNav.hidden = false;
        })
        .finally(function () { loading = false; });
    });
  }
  // Cart: quantity stepper
  document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('.cart__qty-input');
    var form = wrap.closest('[data-cart-form]');
    var updateBtn = form && form.querySelector('[data-cart-update]');
    if (!input) return;
    var setQty = function (next) {
      input.value = Math.max(0, next);
      if (updateBtn) updateBtn.click();
    };
    wrap.querySelector('[data-cart-qty-decrease]')?.addEventListener('click', function () {
      setQty(Number(input.value || 0) - 1);
    });
    wrap.querySelector('[data-cart-qty-increase]')?.addEventListener('click', function () {
      setQty(Number(input.value || 0) + 1);
    });
  });

  // Product images: add .is-loaded when finished loading (fade + scale reveal)
  document.querySelectorAll('.product-card__img--primary').forEach(function (img) {
    if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  });
})();
